<template>
  <div
    class="loader-wrapper"
    :class="{
      stretched: stretch,
      inverse: inverse,
      inline: inline,
    }"
  >
    <div class="loader"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    stretch: Boolean,
    inverse: Boolean,
    inline: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
.loader-wrapper:not(.inline) {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow: hidden;

  &.stretched {
    height: 100vh;
    width: 100vw;
    position: static;
  }
  &.inverse {
    background: none;
  }

  .loader {
    &::after {
      content: "";
      position: absolute;
      width: 75px;
      height: 75px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      border: 10px solid rgb(239, 239, 239);
      border-top-color: var(--theme-color);
      border-radius: 50%;
      animation: button-loading-spinner 1s ease infinite;
    }
  }
}

.loader-wrapper.inline {
  display: flex;
  justify-content: center;
}

.loader-wrapper.inline .loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid var(--theme-color);
  width: 120px;
  height: 120px;
  animation: button-loading-spinner 1s ease infinite;
}

@keyframes button-loading-spinner {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}
</style>
